import * as types from "../actions/types";

const initialState = {
  list: [],
  loading: false,
  item: {},
  loadingItem: false,
  name_exams: [],
  add_name_exams: [],
  physical_training: [],
  aplicantList: [],
};

export default function applicant_group(state = initialState, action) {
  switch (action.type) {
    case types.GET_APLICANT_GROUP_LIST:
      return {
        ...state,
        list: action.payload
      };
      case types.SET_APLICANT_GROUP_LIST_LOADING:
        return {
          ...state,
          loading: action.payload
        };
      case types.SET_APLICANT_GROUP_BY_ID:
        return {
          ...state,
          item: action.payload
        };
        case types.SET_APLICANT_GROUP_BY_ID_LOADING:
          return {
            ...state,
            loadingItem: action.payload
          };
        case types.SET_APLICANT_GROUP_NAME_EXAMS:
          return {
            ...state,
            name_exams: action.payload
          };
        case types.SET_APLICANT_GROUP_NAME_EXAMS_ADD:
          return {
            ...state,
            add_name_exams: action.payload
          };
        case types.SET_APLICANT_GROUP_PHYSICAL_TRAINING:
          return {
            ...state,
            physical_training: action.payload
          };
        case types.SET_APLICANT_GROUP_ADD_LIST:
          return {
            ...state,
            aplicantList: action.payload
          };
    default:
      return state;
  }
}